import React, { useEffect, useContext, useState } from 'react';
import { appContext } from "../../../AppContext";
import {useFetch} from '@utils'
import { Spin, message, List, Button, Divider, } from 'antd';
import CharacterModal from '../player/CharacterModal';
import LarpTable from '../../table/LarpTable';
import characterAdminColumns from '../columns/characterColumns';
import Avatar from '../../avatar/avatar';
import { useHistory } from "react-router-dom";
import TodoListOverview from './TodoListOverview';


export default function PlayerCharactersAdmin({
    characterTypes,
    characterStatusses,
    races
}) {

     const [appState] = useContext(appContext);
     const [doFetch, FetchType] = useFetch();
     const[isLoading, setIsLoading] = useState(true)
     const [searchValue, setSearchValue] = useState("");
     const [dataSource, setDataSource] = useState([]);
     const [result, setResult] = useState([])
     const [isModalVisible, setIsModalVisible] = useState(false);
     const [selectedRecord, setSelectedRecord] = useState(undefined);
     const [unReadComments, setUnReadComments] = useState([]);
     const [listSource, setListSource] = useState([]);
     const history = useHistory();

      useEffect(() => {
        if(result.length <= 0) {
          setDataSource([]);
          return;
        }
        const newDataSource = result.filter(_ => {
            return (_.name === null && searchValue === "" ) ||
            _.name?.toLowerCase().includes(searchValue.toLowerCase()) ||
            _.larper?.name?.toLowerCase().includes(searchValue.toLowerCase()) ||
            _.skills?.find(skill => 
              skill.skill?.name?.toLowerCase().includes(searchValue.toLowerCase())
            ) !== undefined
          }
        )
        setDataSource(newDataSource);




      }, [result, searchValue])

      useEffect(() => {
        // const found = unReadComments?.find(_ => _.characterId === record.id)
        if(unReadComments.length > 0) {
          const unreadCharacters = result.filter(_ => unReadComments.find(cm => cm.characterId === _.id))

          setListSource(unreadCharacters.map(_ => {
            return (
                    <List.Item>
                      <List.Item.Meta
                        avatar={<Avatar name={_.larper.name} />}
                        title={`${_.name}`}
                      />
                        <Button onClick={() => window.open(`${appState.ownUrl}/character?id=${_.id}`, '_blank')}>View</Button>
                    </List.Item>
            )
          }));
        }
      }, // eslint-disable-next-line
      [unReadComments, result])

      useEffect(() => {
        refresh();
          }, // eslint-disable-next-line
      [searchValue, appState.storyId])

      function refresh()
      {
          const url = `/api/character/GetAll`
          doFetch(url)
          .then((response) => onCharactersLoaded(response.isSuccess, response.result))
  
          function onCharactersLoaded(isSuccess, result) { 
            if(isSuccess) {
              setResult(result);
              setIsLoading(false);


              setSelectedRecord(result.find(_ => _.id === selectedRecord?.id))

              return;
            }
            setResult([])
            message.error('Could not get characters');
            setIsLoading(false);
          }

          const url2 = `/api/comment/character/getUnseenList`
          doFetch(url2)
          .then((response) => onUnseenLoaded(response.isSuccess, response.result))
  
          function onUnseenLoaded(isSuccess, result) { 
            if(isSuccess) {
              setUnReadComments(result)            
              return;
            }
            setUnReadComments([])
          }
      }

      if(isLoading)
      {
          return <Spin />
      }

      function onRowClick(record)
      {
        setSelectedRecord(record);
        setIsModalVisible(true);
      }


      function onAddSkillPoint(record)
      {
          const url = `/api/character/AddSkillPoint/${record.id}`
          doFetch(url, FetchType.POST, null)
              .then((response) => onRemove(response.isSuccess))
  
          function onRemove(isSuccess) {
            isSuccess ? refresh() : message.error('Could not update character skillpoints');
          }
      }

      const columns = characterAdminColumns(characterTypes, characterStatusses, onRowClick, onAddSkillPoint, unReadComments, appState)

      const isBigScreen = window.innerWidth > 481;
    return (
      <>
      <div id="characters-admin-body" 
              style={{ display:"flex", 
              flexDirection: isBigScreen ? 'row' : 'column',
              justifyContent: 'space-between'}}>

          <div id="characters-admin-characters" style={{ width: isBigScreen ? "65%" : "auto" }}>
            <Divider orientation="left">Characters</Divider>
            <LarpTable 
              columns={columns}
              dataSource={dataSource}
              onDoubleRowClick={onRowClick}
              setSearchValue={setSearchValue}
              refresh={refresh}
            />
          </div>

          <div id="characters-admin-unread" style={{ width: isBigScreen ? "30%" : "auto" }}>
            <Divider orientation="left">Unread comments</Divider>
            <List
                itemLayout="horizontal"
                dataSource={listSource}
                renderItem={item =>
                  item
                }
            /> 

            <TodoListOverview />
          </div>
        </div>
        {isModalVisible && <CharacterModal 
          refresh={refresh}
          setIsModalVisible={setIsModalVisible}
          isModalVisible={isModalVisible}
          characterTypes={characterTypes}
          characterStatusses={characterStatusses}
          races={races}
          originalCharacter={selectedRecord}
        />}    
      </>
    )
}